import { readonly, ref, Ref } from "vue";

export function confirmCancelMessageManager() {
  const showConfirmModal: Ref<boolean> = ref(false);
  const confirmMessage: Ref<string> = ref("");

  function closeConfirmModal(callback?: () => void): void {
    showConfirmModal.value = false;
    if (typeof callback !== "undefined") {
      callback();
    }
  }

  async function closeConfirmModalAsync(
    callback?: () => Promise<void>
  ): Promise<void> {
    showConfirmModal.value = false;
    if (typeof callback !== "undefined") {
      await callback();
    }
  }

  function openConfirmModal(message: string): void {
    showConfirmModal.value = true;
    confirmMessage.value = message;
  }

  return {
    openConfirmModal,
    closeConfirmModal,
    closeConfirmModalAsync,
    showConfirmModal: readonly(showConfirmModal),
    confirmMessage: readonly(confirmMessage),
  };
}
